import styled from '@emotion/styled';

type GridProps = {
  columns: number;
  gapX?: boolean;
  gapY?: boolean;
};

const Grid = styled.div<GridProps>`
  @media (min-width: 567px) {
    display: grid;
    grid-template-columns: ${({ columns }) => `repeat(${columns}, 1fr)`};
    ${({ gapX = true }) => gapX && 'grid-column-gap: 1rem;'}
    ${({ gapY = false }) => gapY && 'grid-row-gap: 1rem;'}
  }
`;

export default Grid;
